import React from 'react';
import Modal from '../common/Modal';
import { useSettings } from '../../context/SettingsContext';

const SettingsModals = () => {
  const {
    systemPrompt,
    setSystemPrompt,
    isEditingPrompt,
    setIsEditingPrompt,
    isEditingVectorSettings,
    setIsEditingVectorSettings,
    vectorClassifierPrompt,
    setVectorClassifierPrompt,
    vectorClassifierThreshold,
    setVectorClassifierThreshold,
    isProductClassifierOpen,
    setIsProductClassifierOpen,
    settings,
    handleSettingChange,
    isEditingVectorStorePrompt,
    setIsEditingVectorStorePrompt,
    vectorStorePrompt,
    setVectorStorePrompt,
    assistantId,
    setAssistantId,
    vectorstoreId,
    setVectorstoreId,
    isLoadingSettings,
    settingsError,
    handleUpdateSystemPrompt,
    handleSaveVectorSettings,
    handleSaveVectorStoreSettings,
    handleSaveProductClassifierSettings
  } = useSettings();

  return (
    <>
      {/* System Prompt Modal */}
      <Modal 
        isOpen={isEditingPrompt} 
        onClose={() => setIsEditingPrompt(false)}
      >
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-white mb-4">Chat-Anweisungen bearbeiten</h3>
          <textarea
            value={systemPrompt}
            onChange={(e) => setSystemPrompt(e.target.value)}
            className="w-full bg-gray-700 text-white rounded p-2 text-sm min-h-[200px]"
            placeholder="Geben Sie Chat-Anweisungen ein..."
          />
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => setIsEditingPrompt(false)}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-500"
            >
              Abbrechen
            </button>
            <button
              onClick={handleUpdateSystemPrompt}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400"
            >
              Änderungen speichern
            </button>
          </div>
        </div>
      </Modal>

      {/* Vector Classifier Settings Modal */}
      <Modal isOpen={isEditingVectorSettings} onClose={() => setIsEditingVectorSettings(false)}>
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-white mb-4">Vektor-Klassifikator Einstellungen</h3>
          
          {settingsError && (
            <div className="text-red-500 text-sm mb-4">
              {settingsError}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Klassifikator-Anweisung
            </label>
            <textarea
              value={vectorClassifierPrompt}
              onChange={(e) => setVectorClassifierPrompt(e.target.value)}
              className="w-full h-64 p-2 bg-gray-700 text-white rounded resize-none"
              disabled={isLoadingSettings}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Schwellenwert (0.0 - 1.0)
            </label>
            <input
              type="number"
              min="0"
              max="1"
              step="0.1"
              value={vectorClassifierThreshold}
              onChange={(e) => setVectorClassifierThreshold(e.target.value)}
              className="w-full p-2 bg-gray-700 text-white rounded"
              disabled={isLoadingSettings}
            />
          </div>
          <div className="flex justify-end space-x-3">
            <button
              onClick={() => setIsEditingVectorSettings(false)}
              className="px-4 py-2 text-gray-400 hover:text-white"
              disabled={isLoadingSettings}
            >
              Abbrechen
            </button>
            <button
              onClick={handleSaveVectorSettings}
              className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 flex items-center ${
                isLoadingSettings ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              disabled={isLoadingSettings}
            >
              {isLoadingSettings ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Speichern...
                </>
              ) : (
                'Änderungen speichern'
              )}
            </button>
          </div>
        </div>
      </Modal>

      {/* Vector Store Prompt Modal */}
      <Modal isOpen={isEditingVectorStorePrompt} onClose={() => setIsEditingVectorStorePrompt(false)}>
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-white mb-4">Vektor-Speicher Einstellungen</h3>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Assistent-ID</label>
            <input
              type="text"
              value={assistantId}
              onChange={(e) => setAssistantId(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
              placeholder="Geben Sie Assistent-ID ein"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Vektor-Speicher Anweisung</label>
            <textarea
              value={vectorStorePrompt}
              onChange={(e) => setVectorStorePrompt(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white h-40"
              placeholder="Geben Sie Vektor-Speicher Anweisung ein"
            />
          </div>
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => setIsEditingVectorStorePrompt(false)}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-500"
            >
              Abbrechen
            </button>
            <button
              onClick={handleSaveVectorStoreSettings}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400"
              disabled={isLoadingSettings}
            >
              Speichern
            </button>
          </div>
          {settingsError && (
            <div className="text-red-500 text-sm mt-2">
              {settingsError}
            </div>
          )}
        </div>
      </Modal>

      {/* Product Classifier Settings Modal */}
      <Modal isOpen={isProductClassifierOpen} onClose={() => setIsProductClassifierOpen(false)}>
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-white mb-4">Produkt-Klassifikator Einstellungen</h3>
          
          {settingsError && (
            <div className="text-red-500 text-sm mb-4">
              {settingsError}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Klassifikator-Anweisung
            </label>
            <textarea
              value={settings['product-classifier-prompt'] || ''}
              onChange={(e) => handleSettingChange('product-classifier-prompt', e.target.value)}
              className="w-full h-64 p-2 bg-gray-700 text-white rounded resize-none"
              disabled={isLoadingSettings}
              placeholder="Geben Sie Produkt-Klassifikator Anweisung ein..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Schwellenwert (0.0 - 1.0)
            </label>
            <input
              type="number"
              min="0"
              max="1"
              step="0.1"
              value={settings['product-classifier-threshold'] || ''}
              onChange={(e) => handleSettingChange('product-classifier-threshold', e.target.value)}
              className="w-full p-2 bg-gray-700 text-white rounded"
              disabled={isLoadingSettings}
              placeholder="Geben Sie Schwellenwert ein..."
            />
          </div>
          <div className="flex justify-end space-x-3">
            <button
              onClick={() => setIsProductClassifierOpen(false)}
              className="px-4 py-2 text-gray-400 hover:text-white"
              disabled={isLoadingSettings}
            >
              Abbrechen
            </button>
            <button
              onClick={handleSaveProductClassifierSettings}
              className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 flex items-center ${
                isLoadingSettings ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              disabled={isLoadingSettings}
            >
              {isLoadingSettings ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Speichern...
                </>
              ) : (
                'Änderungen speichern'
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SettingsModals;
